<div [ngSwitch]="Model?.type" class="d-flex flex-column answer-option-view">
    <div>
        <label class="answer-option-title" translate>{{Model?.label}}</label>
    </div>

    <ng-template [ngSwitchCase]="answerTypes.Text">

    </ng-template>
    <ng-template [ngSwitchCase]="answerTypes.Numerical">
        <ul>
            <li>
                <div class="d-flex justify-content-between align-items-center">
                    <span translate>LBL.MEASUREMENT_UNIT</span>
                    <label>{{Model?.attributes.unit}}</label>
                </div>
            </li>
            <li>
                <div class="d-flex justify-content-between align-items-center">
                    <span translate>LBL.MINIMUM</span>
                    <label>{{Model?.attributes.min}}</label>
                </div>
            </li>
            <li>
                <div class="d-flex justify-content-between align-items-center">
                    <span translate>LBL.MAXIMUM</span>
                    <label>{{Model?.attributes.max}}</label>
                </div>
            </li>
        </ul>
    </ng-template>
    <ng-template [ngSwitchCase]="answerTypes.OptionalBool">
        
    </ng-template>
    <ng-template [ngSwitchCase]="answerTypes.Radio">

    </ng-template>
    <ng-template [ngSwitchCase]="answerTypes.Checkbox">

    </ng-template>
    <ng-template [ngSwitchCase]="answerTypes.Rating">

    </ng-template>

    <ng-template [ngIf]="Model?.type == answerTypes.OptionalBool">
        <span class="mb-1" translate>LBL.OPTIONS</span>
        <ul>
            <li *ngFor="let option of Model?.values">
                {{option.label}}
                <span class="ml-2 badge badge-primary badge-pill float-right" *ngIf="option.original != option.label" translate>{{option.original}}</span>
            </li>
        </ul>
    </ng-template>
    <ng-template [ngIf]="Model?.type == answerTypes.Radio || Model?.type == answerTypes.Checkbox  || Model?.type == answerTypes.Rating">
        <ul>
            <li *ngFor="let option of Model?.values" [ngClass]="{'text-success': option.isValid, 'text-danger': !option.isValid}">
                {{option.label}}
            </li>
        </ul>
    </ng-template>
</div>
